<template>
  <div class="check-email-container">
    <div class="check-email-card">
      <div class="email-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="M22 6L12 13L2 6"/>
        </svg>
      </div>
      <h1>Check Your Email</h1>
      <p class="description">
        We've sent you an email with instructions to reset your password.
      </p>
      <router-link to="/login" class="back-to-login">
        Back to Login
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckEmailView'
}
</script>

<style scoped>
.check-email-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 20px;
  padding-top: 100px;
  background-color: var(--bg-primary);
}

.check-email-card {
  max-width: 450px;
  width: 100%;
  padding: 40px;
  background-color: var(--bg-secondary);
  border-radius: 8px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border-color);
  text-align: center;
}

.email-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  border: 2px solid var(--success-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--success-color);
}

.email-icon svg {
  width: 40px;
  height: 40px;
}

h1 {
  color: var(--text-primary);
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 16px;
}

.description {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 24px;
}

.description strong {
  color: var(--text-primary);
}

.back-to-login {
  display: inline-block;
  padding: 12px 32px;
  background-color: var(--accent-color);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.back-to-login:hover {
  background-color: var(--accent-hover);
}
</style>
